import { EventEmitter } from 'events';

import logger from 'logger';


const UNIQUE_ID_RANDOM_SIZE = 1000000;
const ID_BASE = 36;

export default class TrackingService extends EventEmitter {
  TYPES = ['event', 'callback'];
  GLOBALS = {};

  CALLBACKS = {};
  HANDLED = {
    event: [],
    callback: [],
  };

  TRACKING_EVENT_NAME = 'Cam4InternalEvents';
  VERSION = '2';

  constructor() {
    super();

    this.logger = logger.child({ childName: 'tracking' });
    this.instanceId = this.generateUniqueID();
  }

  save = (name, value) => {
    this.GLOBALS[name] = value;
  };

  generateUniqueID(intParts = []) {
    const parts = Array.isArray(intParts) ? intParts : [intParts];

    const prefix = parts.join('');
    const now = Date.now();
    const random = Math.floor(Math.random() * UNIQUE_ID_RANDOM_SIZE);

    const concatenate = `${prefix}${now}${random}`;
    const concatenateInt = parseInt(concatenate, 10);
    const hash = concatenateInt.toString(ID_BASE);

    return hash;
  }

  getNameForListener(name) {
    return `on${name.charAt(0).toUpperCase() + name.slice(1)}`;
  }

  register(tracker) {
    tracker.init(this);
  }

  on(event, resolver, options = {}) {
    const { type = 'event' } = options;

    switch (type) {
      case 'event':
        super.on(this.getNameForListener(event), (e) => {
          resolver?.(e);
        });

        this.HANDLED[type].push(event);
        break;

      case 'callback':
        this.CALLBACKS[event] = this.CALLBACKS[event] || [];
        this.CALLBACKS[event].push(resolver);

        this.HANDLED[type].push(event);
        break;

      default:
    }
  }

  emit(event, payload) {
    super.emit(this.getNameForListener(event), payload);
  }

  exec(descriptor, payload) {
    if (this.HANDLED.callback.includes(descriptor)) {
      for (const resolver of this.CALLBACKS[descriptor]) {
        resolver(payload);
      }
    }
  }

  track(capture, payload) {
    const user = this.GLOBALS.user || {};
    const member = {};
    const service = {
      instanceId: this.instanceId,
      version: this.VERSION,
    };

    member.known = 0;
    if (user['Logged In'] === 'yes') {
      member.uid = user.uid;
      member.name = user.Username;
      member.known = 1;
    }

    const trackingPayload = {
      name: capture,
      details: payload,
      service,
      member,
    };

    this.emitEvent(trackingPayload);
  }

  emitEvent(payload) {
    window.dispatchEvent(new CustomEvent(this.TRACKING_EVENT_NAME, { detail: payload }));
  }
}
